import { useMemo } from 'react';
import { getLargestTab } from './Card.helpers';

export function useTabSizing(
  tabs: string[],
  padding = 24,
  baseCharacterWidth = 8,
  minSize: number | undefined = 75
): number {
  return useMemo(() => {
    const largestTabLength = getLargestTab(tabs);
    const calculated = baseCharacterWidth * largestTabLength + padding;

    return minSize && minSize > calculated ? minSize : calculated;
  }, [tabs]);
}
